const theme = {
    colors: {
        primary: "rgba(6, 214, 160, 1)",
        secondary: "#b5179e",
    },
};

export default theme;